import { loadScript as e } from "./loadScript.mjs";
//#region src/web/sdk/loadGoogleSdk.ts
var t = "https://accounts.google.com/gsi/client";
async function n() {
	if (await e(t), !window.google?.accounts?.id) throw Error("Google Identity Services failed to initialize");
	return window.google.accounts.id;
}
//#endregion
export { n as loadGoogleSdk };
